import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

function GecmisKasaAra({ sube }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const subeFromUrl = queryParams.get('sube') || 'Bilinmeyen Şube';
  const [selectedDate, setSelectedDate] = useState('');
  const [kasaData, setKasaData] = useState(null);
  const [bankaBakiyesi, setBankaBakiyesi] = useState(0);
  const [krediKartiBakiyesi, setKrediKartiBakiyesi] = useState(0);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // TAKI ÜRÜN LİSTEDEN ÇIKARILDI
  const categories = [
    {
      key: 'sarrafiye',
      name: 'Sarrafiye',
      field: 'adet',
      fieldLabel: 'Adet',
      productWidth: '240px',
      totalWidth: '300px',
      items: [
        { key: 'eskiZiynetCeyrek', label: 'Eski Ziynet Çeyrek' },
        { key: 'yeniZiynetCeyrek', label: 'Yeni Ziynet Çeyrek' },
        { key: 'eskiZiynetYarim', label: 'Eski Ziynet Yarım' },
        { key: 'yeniZiynetYarim', label: 'Yeni Ziynet Yarım' },
        { key: 'eskiZiynetTam', label: 'Eski Ziynet Tam' },
        { key: 'yeniZiynetTam', label: 'Yeni Ziynet Tam' },
        { key: 'eskiZiynetGremse', label: "Eski Ziynet 2.5'lu Gremse" },
        { key: 'yeniZiynetGremse', label: "Yeni Ziynet 2.5'lu Gremse" },
        { key: 'eskiZiynetBesli', label: 'Eski Ziynet Beşli' },
        { key: 'yeniZiynetBesli', label: 'Yeni Ziynet Beşli' },
        { key: 'cumhuriyetAtaCeyrek', label: 'Cumhuriyet Ata Çeyrek' },
        { key: 'cumhuriyetAtaYarim', label: 'Cumhuriyet Ata Yarım' },
        { key: 'cumhuriyetAta', label: 'Cumhuriyet Ata' },
        { key: 'cumhuriyetAtaGremse', label: "Cumhuriyet Ata 2.5'lu Gremse" },
        { key: 'cumhuriyetAtaBesli', label: 'Cumhuriyet Ata Beşli' },
        { key: 'resatCeyrek', label: 'Reşat Çeyrek' },
        { key: 'resatYarim', label: 'Reşat Yarım' },
        { key: 'resat', label: 'Reşat' },
        { key: 'resatGremse', label: "Reşat 2.5'lu Gremse" },
        { key: 'resatBesli', label: 'Reşat Beşli' }
      ]
    },
    {
      key: 'gramAltin',
      name: 'Gram Altın',
      field: 'adet',
      fieldLabel: 'Adet',
      productWidth: '160px',
      totalWidth: '220px',
      items: [
        { key: 'birGram22Ayar', label: '1 Gram 22 Ayar' },
        { key: 'yariGram22Ayar', label: '0.50 Gram 22 Ayar' },
        { key: 'ceyrekGram22Ayar', label: '0.25 Gram 22 Ayar' },
        { key: 'birGram24Ayar', label: '1 Gram 24 Ayar' },
        { key: 'yariGram24Ayar', label: '0.50 Gram 24 Ayar' },
        { key: 'ceyrekGram24Ayar', label: '0.25 Gram 24 Ayar' },
        { key: 'ikiBucukGram24Ayar', label: '2.50 Gram 24 Ayar' },
        { key: 'besGram24Ayar', label: '5 Gram 24 Ayar' },
        { key: 'onGram24Ayar', label: '10 Gram 24 Ayar' },
        { key: 'yirmiGram24Ayar', label: '20 Gram 24 Ayar' },
        { key: 'elliGram24Ayar', label: '50 Gram 24 Ayar' },
        { key: 'yuzGram24Ayar', label: '100 Gram 24 Ayar' }
      ]
    },
    {
      key: 'hurda',
      name: 'Hurda',
      field: 'gram',
      fieldLabel: 'Gram',
      productWidth: '175px',
      totalWidth: '235px',
      items: [
        { key: 'yirmiDortAyarHurda', label: '24 Ayar Hurda' },
        { key: 'yirmiIkiAyarBilezikHurda', label: '22 Ayar Bilezik Hurda' },
        { key: 'yirmiIkiAyarHurda', label: '22 Ayar Hurda' },
        { key: 'yirmiBirAyarHurda', label: '21 Ayar Hurda' },
        { key: 'onSekizAyarHurda', label: '18 Ayar Hurda' },
        { key: 'onDortAyarHurda', label: '14 Ayar Hurda' },
        { key: 'onAyarHurda', label: '10 Ayar Hurda' },
        { key: 'sekizAyarHurda', label: '8 Ayar Hurda' }
      ]
    },
    {
      key: 'doviz',
      name: 'Döviz',
      field: 'adet',
      fieldLabel: 'Birim',
      productWidth: '290px',
      totalWidth: '350px',
      items: [
        { key: 'tl', label: 'TL - Türk Lirası' },
        { key: 'usd', label: 'USD - Amerikan Doları' },
        { key: 'eur', label: 'EUR - Euro' },
        { key: 'gbp', label: 'GBP - İngiliz Sterlini' },
        { key: 'chf', label: 'CHF - İsviçre Frangı' },
        { key: 'aud', label: 'AUD - Avustralya Doları' },
        { key: 'cad', label: 'CAD - Kanada Doları' },
        { key: 'sar', label: 'SAR - Suudi Arabistan Riyali' },
        { key: 'aed', label: 'AED - Birleşik Arap Emirlikleri Dirhemi' },
        { key: 'qar', label: 'QAR - Katar Riyali' },
        { key: 'mad', label: 'MAD - Fas Dirhemi' },
        { key: 'jod', label: 'JOD - Ürdün Dinarı' },
        { key: 'kwd', label: 'KWD - Kuveyt Dinarı' },
        { key: 'cny', label: 'CNY - Çin Yuanı' },
        { key: 'rub', label: 'RUB - Rus Rublesi' },
        { key: 'bgn', label: 'BGN - Bulgar Levası' }
      ]
    }
  ];

  const handleDateSelect = async (date) => {
    setSelectedDate(date);
    setLoading(true);
    try {
      const docRef = doc(db, 'subeler', sube || subeFromUrl, 'gunsonukasa', date);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setKasaData(data);

        // Dökümanda yoksa banka için geçmişten hesapla, kredi kartı için sadece seçilen günü hesapla
        let calculatedBanka = data.bankaBakiyesi ?? 0;
        let calculatedKredi = 0;

        const selectedDayStart = new Date(date);
        selectedDayStart.setHours(0, 0, 0, 0);
        const selectedDayEnd = new Date(selectedDayStart);
        selectedDayEnd.setDate(selectedDayEnd.getDate() + 1);

        if (data.bankaBakiyesi === undefined) {
          const selectedDay = new Date(date);
          selectedDay.setHours(23, 59, 59, 999);
          const islemlerQuery = query(
            collection(db, 'subeler', sube || subeFromUrl, 'islemler'),
            where('timestamp', '<=', selectedDay)
          );

          const islemlerSnapshot = await getDocs(islemlerQuery);
          calculatedBanka = 0;

          islemlerSnapshot.docs.forEach((itemDoc) => {
            const islem = itemDoc.data();
            const havale = parseFloat(islem.havaleEft) || 0;

            if (['Satış', 'Giriş'].includes(islem.islemTuru)) {
              if (havale > 0) calculatedBanka += havale;
            } else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(islem.islemTuru)) {
              if (havale > 0) calculatedBanka -= havale;
            }
          });
        }

        // Kredi kartı HER ZAMAN sadece seçilen günün işlemlerinden hesaplanır
        const krediKartQuery = query(
          collection(db, 'subeler', sube || subeFromUrl, 'islemler'),
          where('timestamp', '>=', selectedDayStart),
          where('timestamp', '<', selectedDayEnd)
        );
        const krediKartSnapshot = await getDocs(krediKartQuery);
        calculatedKredi = 0;
        krediKartSnapshot.docs.forEach((itemDoc) => {
          const islem = itemDoc.data();
          const kredi = parseFloat(islem.krediKarti) || 0;
          if (kredi <= 0) return;

          if (['Satış', 'Giriş'].includes(islem.islemTuru)) {
            calculatedKredi += kredi;
          } else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(islem.islemTuru)) {
            calculatedKredi -= kredi;
          }
        });

        setBankaBakiyesi(calculatedBanka);
        setKrediKartiBakiyesi(calculatedKredi);
        setError('');
      } else {
        setError('Seçilen tarihe ait veri bulunamadı.');
        setKasaData(null);
        setBankaBakiyesi(0);
        setKrediKartiBakiyesi(0);
      }
      setLoading(false);
    } catch (err) {
      console.error('Veri alma hatası:', err);
      setError(`Hata: ${err.message}`);
      setLoading(false);
    }
  };

  // İlk yüklenmede değil, sadece tarih seçildiğinde loading gösterilecek.
  // Sayfa ilk açıldığında boş gelmesi normal.

  const nakitKasa = kasaData?.doviz?.tl?.adet || 0;
  const toplamVarlik = nakitKasa + bankaBakiyesi + krediKartiBakiyesi;

  return (
    <div className="gka-page" style={{
      background: 'linear-gradient(180deg, #f8fafd 0%, #eff3f8 100%)',
      borderRadius: '12px',
      padding: '8px 10px 10px',
      boxShadow: '0 10px 24px rgba(15, 23, 42, 0.10)',
      border: '1px solid #d9e2ee',
      width: '1580px',
      height: '735px',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      fontFamily: "'Roboto', sans-serif",
      margin: '-10px 0 4px 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="gka-header" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '0 4px 6px',
        padding: '4px 8px',
        borderBottom: '1px solid #dbe4ef'
      }}>
        <h2 className="gka-title" style={{ margin: 0, fontSize: '18px', fontWeight: 800, color: '#1e293b', letterSpacing: '0.2px' }}>
          Geçmiş kasa ara
        </h2>
        <span className="gka-date-label" style={{ fontSize: '13px', color: '#64748b', fontWeight: 700 }}>
          {selectedDate ? `${selectedDate.split('-').reverse().join('.')} seçili` : 'Tarih seçiniz'}
        </span>
      </div>

      <div className="gka-date-wrap" style={{ padding: '6px 10px' }}>
        <div className="gka-date-shell">
          <input
            className="gka-date-input"
            type="date"
            value={selectedDate}
            onChange={(e) => handleDateSelect(e.target.value)}
            style={{
              padding: '8px 10px',
              fontSize: '15px',
              fontFamily: "'Roboto', sans-serif",
              border: '1px solid #cfd9e5',
              borderRadius: '8px',
              outline: 'none',
              width: '220px',
              background: '#fff',
              boxSizing: 'border-box'
            }}
          />
        </div>
      </div>

      {loading ? (
        <div className="gka-status" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <p style={{ fontSize: '16px', color: '#4b5563', fontWeight: 'bold', padding: '10px 20px', backgroundColor: '#ffffff', borderRadius: '6px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)' }}>
            Yükleniyor...
          </p>
        </div>
      ) : kasaData ? (
        <div className="gka-main-wrap" style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start', gap: '10px', flex: 1, minHeight: 0 }}>
          <div className="gka-sidebar" style={{ width: '235px', background: 'linear-gradient(180deg, #fffdf4 0%, #faf5e8 100%)', border: '1px solid #e4dac4', borderRadius: '8px', boxShadow: '0 4px 10px rgba(15, 23, 42, 0.06)', padding: '8px', flexShrink: 0 }}>
            <div className="gka-sidebar-branch" style={{ fontSize: '13px', fontWeight: 800, color: '#1f2937' }}>
              {(sube || subeFromUrl || 'ŞUBE').toUpperCase().replace('_', ' ')}
            </div>
            <div style={{ fontSize: '10px', color: '#64748b', fontWeight: 700, marginBottom: '8px' }}>
              Geçmiş kasa
            </div>
            <div className="gka-summary-grid" style={{ display: 'grid', gap: '6px' }}>
              <div className="gka-summary-card" style={{ border: '1px solid #bff0d8', borderLeft: '6px solid #059669', borderRadius: '12px', padding: '11px 10px', minHeight: '82px', background: '#ffffff', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'linear-gradient(135deg, #06b27a 0%, #059669 100%)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '24px', boxShadow: '0 6px 14px rgba(5,150,105,0.35)' }}>₺</div>
                <div>
                  <div style={{ fontSize: '14px', color: '#64748b', fontWeight: 800, letterSpacing: '0.8px' }}>NAKİT</div>
                  <div style={{ fontSize: '24px', color: '#0f172a', fontWeight: 900, lineHeight: 1 }}>{nakitKasa.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                </div>
              </div>
              <div className="gka-summary-card" style={{ border: '1px solid #dbe7ff', borderLeft: '6px solid #2563eb', borderRadius: '12px', padding: '11px 10px', minHeight: '82px', background: '#ffffff', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '20px', boxShadow: '0 6px 14px rgba(37,99,235,0.3)' }}>🏦</div>
                <div>
                  <div style={{ fontSize: '14px', color: '#64748b', fontWeight: 800, letterSpacing: '0.8px' }}>BANKA</div>
                  <div style={{ fontSize: '24px', color: '#0f172a', fontWeight: 900, lineHeight: 1 }}>{bankaBakiyesi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                </div>
              </div>
              <div className="gka-summary-card" style={{ border: '1px solid #ffd7bf', borderLeft: '6px solid #ea580c', borderRadius: '12px', padding: '11px 10px', minHeight: '82px', background: '#ffffff', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '20px', boxShadow: '0 6px 14px rgba(234,88,12,0.3)' }}>▭</div>
                <div>
                  <div style={{ fontSize: '14px', color: '#64748b', fontWeight: 800, letterSpacing: '0.8px' }}>KREDİ KARTI</div>
                  <div style={{ fontSize: '24px', color: '#0f172a', fontWeight: 900, lineHeight: 1 }}>{krediKartiBakiyesi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                </div>
              </div>
              <div className="gka-summary-card" style={{ border: '1px solid #ddd7ff', borderLeft: '6px solid #4f46e5', borderRadius: '12px', padding: '11px 10px', minHeight: '82px', background: '#ffffff', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '22px', boxShadow: '0 6px 14px rgba(79,70,229,0.3)' }}>Σ</div>
                <div>
                  <div style={{ fontSize: '14px', color: '#64748b', fontWeight: 800, letterSpacing: '0.8px' }}>TOPLAM</div>
                  <div style={{ fontSize: '24px', color: '#0f172a', fontWeight: 900, lineHeight: 1 }}>{toplamVarlik.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="gka-columns" style={{ display: 'flex', flexDirection: 'row', gap: '10px', overflow: 'hidden', boxSizing: 'border-box', flex: 1, justifyContent: 'center', minHeight: 0 }}>
            {categories.map((category) => (
              <div key={category.key} className="gka-col" style={{ width: category.totalWidth, display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box', background: '#ffffff', border: '1px solid #dfe7f2', borderRadius: '8px', boxShadow: '0 4px 10px rgba(15, 23, 42, 0.05)' }}>
                <h3 style={{ fontSize: '12px', fontWeight: 800, margin: '0', padding: '5px 6px', color: '#334155', borderBottom: '1px solid #e5ebf3', background: '#f8fbff' }}>{category.name}</h3>
                <table className="gka-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', fontSize: '11px', color: '#1f2937', lineHeight: '1.2', boxSizing: 'border-box', fontWeight: '700' }}>
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid #e5e7eb', borderBottom: '1px solid #c58a2f', padding: '4px 5px', width: category.productWidth, fontWeight: '800', fontSize: '11px', textAlign: 'left', background: '#f3f7fd' }}>Ürün</th>
                      <th style={{ border: '1px solid #e5e7eb', borderBottom: '1px solid #c58a2f', padding: '4px 4px', width: '60px', fontWeight: '800', fontSize: '11px', textAlign: 'center', background: '#f3f7fd' }}>{category.fieldLabel}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.items.map((item) => (
                      <tr key={item.key}>
                        <td style={{ border: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '5px 6px', width: category.productWidth, whiteSpace: 'normal', wordWrap: 'break-word', boxSizing: 'border-box', fontWeight: 700, fontSize: '14px', color: '#0f172a' }}>
                          {item.label}
                        </td>
                        <td style={{ border: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '5px 4px', width: '60px', boxSizing: 'border-box', textAlign: 'center', fontSize: '15px', fontWeight: 700, color: '#0f172a', fontFamily: 'Consolas, monospace' }}>
                          {(kasaData[category.key]?.[item.key]?.[category.field] || 0).toLocaleString('tr-TR', {
                            minimumFractionDigits: (category.key === 'hurda' || category.key === 'doviz') ? 2 : 0,
                            maximumFractionDigits: 2
                          })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      ) : error ? (
        <div className="gka-status" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <div style={{ padding: '10px 20px', backgroundColor: '#ffffff', borderRadius: '6px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)', fontSize: '16px', color: '#dc2626', fontWeight: 'bold', textAlign: 'center' }}>
            {error}
          </div>
        </div>
      ) : (
        <div className="gka-status gka-empty" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#64748b', fontWeight: 700 }}>
          Tarih seçerek geçmiş kasa verisini görüntüleyin.
        </div>
      )}

      <style>{`
        .gka-table tbody tr:nth-child(odd) td {
          background: #fcfdff;
        }

        /* --- MOBİL: Geçmiş Kasa Ara (masaüstü inline stillere dokunulmaz) --- */
        /* Kompakt duzen: telefonlar + dokunmatik tabletler. Sayfa kabuğu
           1580px genisliginde yerlesiyordu ve tablette tasiyordu. */
        @media (max-width: 1649px), (max-width: 1400px) and (any-pointer: coarse) {
          .gka-page {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            min-width: 0 !important;
            margin: 0 !important;
            padding: 8px 4px 80px !important;
            overflow-x: hidden !important;
            overflow-y: visible !important;
            box-sizing: border-box !important;
            position: static !important;
          }

          .gka-header {
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 4px !important;
            margin: 0 0 10px !important;
            padding: 0 2px 8px !important;
          }

          .gka-title {
            font-size: 17px !important;
          }

          .gka-date-label {
            font-size: 12px !important;
            line-height: 1.35 !important;
          }

          .gka-date-wrap {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            padding: 0 2px 10px !important;
            box-sizing: border-box !important;
          }

          .gka-date-shell {
            width: 100% !important;
            max-width: 100% !important;
            height: 48px !important;
            overflow: hidden !important;
            box-sizing: border-box !important;
            border: 1px solid #cfd9e5 !important;
            border-radius: 8px !important;
            background: #fff !important;
          }

          .gka-date-input {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            height: 48px !important;
            min-height: 0 !important;
            max-height: 48px !important;
            padding: 0 10px !important;
            margin: 0 !important;
            font-size: 16px !important;
            line-height: 48px !important;
            box-sizing: border-box !important;
            border: none !important;
            border-radius: 0 !important;
            background: transparent !important;
            -webkit-box-sizing: border-box !important;
          }

          .gka-status {
            height: auto !important;
            min-height: 120px !important;
            padding: 20px 8px !important;
          }

          .gka-empty {
            height: auto !important;
            font-size: 14px !important;
            text-align: center !important;
            line-height: 1.45 !important;
            padding: 24px 12px !important;
          }

          .gka-main-wrap {
            display: block !important;
            flex: none !important;
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
          }

          .gka-sidebar {
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 0 12px !important;
            padding: 10px !important;
            box-sizing: border-box !important;
          }

          .gka-summary-grid {
            display: grid !important;
            grid-template-columns: 1fr !important;
            gap: 8px !important;
          }

          .gka-summary-card {
            min-height: 0 !important;
            padding: 10px !important;
            flex-direction: row !important;
            align-items: center !important;
            gap: 10px !important;
          }

          .gka-summary-card > div:first-child {
            width: 40px !important;
            height: 40px !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
          }

          .gka-summary-card > div:last-child > div:first-child {
            font-size: 12px !important;
          }

          .gka-summary-card > div:last-child > div:last-child {
            font-size: 20px !important;
          }

          .gka-columns {
            display: block !important;
            flex: none !important;
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
            width: 100% !important;
          }

          .gka-col {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
            margin: 0 0 12px !important;
            box-sizing: border-box !important;
          }

          .gka-col:last-child {
            margin-bottom: 0 !important;
          }

          .gka-col h3 {
            font-size: 13px !important;
            padding: 7px 8px !important;
          }

          .gka-table {
            display: table !important;
            width: 100% !important;
            table-layout: fixed !important;
            font-size: 12px !important;
          }

          .gka-table th,
          .gka-table td {
            padding: 6px 6px !important;
            width: auto !important;
            max-width: none !important;
          }

          .gka-table th:first-child,
          .gka-table td:first-child {
            width: auto !important;
          }

          .gka-table th:last-child,
          .gka-table td:last-child {
            width: 72px !important;
            min-width: 72px !important;
            max-width: 72px !important;
          }

          .gka-table td:first-child {
            font-size: 13px !important;
            line-height: 1.25 !important;
            word-break: break-word !important;
          }

          .gka-table td:last-child {
            font-size: 14px !important;
          }
        }
      `}</style>
    </div>
  );
}

export default GecmisKasaAra;